// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"f3ad96b2","63":"43b93075","144":"ba4f1f54","425":"b3779ee6","432":"f28e8655","859":"e3635e78","954":"95659050"}[chunkId] + ".chunk.js";
};